import { api as API } from '@/services/api'
export const AutoSaveMixin = {
  computed: {
    apiAutoSave () {
      throw Error('api is required')
    }
  },
  methods: {
    mixAutoSave ({ field = '', value = null, rules = [], api = this.apiAutoSave, payloadData = {}, settings = {} }) {
      value = this._prepareValue(value)
      const config = { field, value, api, payloadData }

      if (!this.isAvailableToSave) {
        console.log('auto-save-is-not-available')
        return Promise.resolve({ e: new Error('auto-save-is-not-available'), config })
      }

      return new Promise((resolve) => {
        this._validateRules(value, rules)
          .then(() => {
            return this._autoSave(config, settings)
          })
          .then(() => {
            resolve({ e: null, config, settings })
          })
          .catch((e) => {
            resolve({ e, config, settings })
          })
      })
    },
    _prepareValue (value) {
      const bugValues = ['', undefined, NaN]
      const isBugValue = bugValues.some((bug) => Object.is(bug, value))
      return isBugValue ? null : value
    },
    _autoSave ({ field, value, api, payloadData }, settings) {
      const _data = {
        ...payloadData,
        [field]: value
      }
      return API
        .patch(`${api}`, { ..._data })
        .then(() => {
          this.mixSuccessAutoSave(_data, settings)
        })
        .catch((e) => {
          this.mixErrorAutoSave(_data, settings)
          throw e
        })
    },
    mixSuccessAutoSave (_data, settings) {
      this.data = { ...this.data, ..._data }
    },
    mixErrorAutoSave (_data, settings) {
      this.data = { ...this.data }
    },
    _validateRules (value, rules) {
      return Promise.all(rules.map(rule => this._validateRule(rule, value)))
    },
    _validateRule (rule, value) {
      return new Promise((resolve, reject) => {
        const callback = function (result) {
          if (result instanceof Error) {
            reject(result)
          } else {
            resolve()
          }
        }
        if (rule && rule.validator && typeof rule.validator === 'function') {
          rule.validator(rule, value, callback)
        } else {
          callback(new Error('Rule must be an object with method validator'))
        }
      })
    }
  }
}
